import BrandLogo from './BrandLogo';

export function isSynesPlan(plan) {
  const value = [
    plan?.codigo,
    plan?.nome,
    plan?.plano,
    typeof plan === 'string' ? plan : '',
  ].filter(Boolean).join(' ').toLowerCase();

  return value.includes('premium') || value.includes('synes');
}

export default function PlanBrand({ plan, compact = false, className = '' }) {
  const premium = isSynesPlan(plan);
  const size = compact ? 'sm' : 'md';
  const logoHeight = compact ? 'h-8' : 'h-12';

  if (!premium) {
    return <BrandLogo size={size} className={className} />;
  }

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <BrandLogo size={size} />
      <span className="rounded-full border border-zinc-700 px-2 py-0.5 text-xs font-semibold text-zinc-400">+</span>
      <img
        src="/synes-ia-logo-transparent.png"
        alt="Synes.ia"
        className={`${logoHeight} w-auto rounded-md object-contain p-1 drop-shadow-lg`}
      />
      <span className="rounded-full border border-yellow-400/30 bg-yellow-400/10 px-2 py-1 text-xs font-semibold text-yellow-300">
        Premium IA
      </span>
    </div>
  );
}
